var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error.statusCode === 404)?_c('div',{staticClass:"text-xs-center"},[_vm._v("\n    ページが見つかりません\n  ")]):(_vm.error.statusCode === 403)?_c('div',{staticClass:"text-xs-center"},[_vm._v("\n    このページを見ることはできません\n  ")]):_c('div',{staticClass:"text-xs-center"},[_vm._v("エラーが発生しました")])])
}
var staticRenderFns = []

export { render, staticRenderFns }